<template>
    <div class="print-layout">
        <Loader :visible="getRequestLoadStatus" />
        <div class="print-header container mt-5"><SiteLogo/>
            <div class="float-right print-icon" @click="print">
               <a href="javascript:void(0);"><PrintIcon/> print this information</a> 
            </div>
        </div>
        <hr/>
        <div class="container my-5" v-if="$route.query.term"> 
            <b>Showing {{$route.query.count}} results for search term: <i>{{$route.query.term}}</i></b>.
            <p>                
                <br><br>Below are your search results. These results have been filtered based on your search term and are provided for convenience purposes only. The below information is not to be interpreted as the only applicable regulations. 
                To view the entire Interactive Zoning By-law, visit <a href="https://www.mississauga.ca/zoningbylaw" target="_blank">www.mississauga.ca/zoningbylaw</a>. 
            </p>
        </div>
        <div class="container my-5" v-if="$route.query.term == null">             
            <p>                
                You are printing a partial view of the Mississauga Interactive Zoning By-law 0225-2007 on {{printDate()}} based on your selection(s). This information is provided for convenience purposes only as it may not reflect recently approved amendments. To view the entire Interactive Zoning By-law, visit <a href="https://www.mississauga.ca/zoningbylaw" target="_blank">www.mississauga.ca/zoningbylaw</a>.
            </p>
        </div>
        <div v-for="item in contents" :key="item.id" class="container my-5">
            <div class="content row">
                <div class="col-12 title">{{item.version}} {{item.title}}</div>
                <div class="col-12 body" v-html="item.description"></div>
            </div>

        </div>
    </div>
</template>

<script>

import apiService from "@/services/byLawViewerAPI";
import Loader from "@/components/Layout/Loader";
import { mapGetters } from "vuex";
import SiteLogo from "@/components/Svg/SiteLogo";
import PrintIcon from "@/components/Svg/PrintIcon";
import "@/assets/sass/preview.scss"; 

export default {
    name: "print-preview",
    components: {
        SiteLogo, PrintIcon, Loader
    }, 
    data(){
      return {
        contents:null,
      }
    },
    props:{
        idlist: { type: String, required: true}
    },
    computed: {   
        ...mapGetters("loader",["getRequestLoadStatus"]),
        ...mapGetters("viewer", ["getDocument"])
    },
    async mounted() {
            var self = this;           
            await apiService.getContentsByIdList(self.idlist)
            .then((response) => {
                self.contents = [];
                self.contents = response.data.bylawList;
            })
            .catch(() => {
                          
            });
       
    },
    methods:{        
        print: function(){
            window.print();
        },
        printDate(){
            var currentDate = new Date();
            return currentDate.toLocaleString();
        }
    }

}
</script>